import React from "react";
import { GeneralInfoEditCameraTab } from "../GeneralInfoEditCameraTab";
import { GeneralInfoEditCameraTabEditMode } from "../GeneralInfoEditCameraTabEditMode";
import { ConnectionsTab } from "../ConnectionsTab";
import { ConnectionsTabEditMode } from "../ConnectionsTabEditMode";
import { NotificationsTab } from "../NotificationsTab";
import { NotificationsTabEditMode } from "../NotificationsTabEditMode";
import { ProductsTab } from "../ProductsTab";
import { ProductsTabEditMode } from "../ProductsTabEditMode";
import { ImmixAlertsTab } from "../ImmixAlertsTab";
import { ImmixAlertsTabEditMode } from "../ImmixAlertsTabEditMode";
import { DiceAlertsTab } from "../DiceAlertsTab";
import { DiceAlertsTabEditMode } from "../DiceAlertsTabEditMode";
import { SureviewAlertsTab } from "../SureviewAlertsTab";
import { SureviewAlertsTabEditMode } from "../SureviewAlertsTabEditMode";
import { AxisTab } from "../AxisTab";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { MobotixTab } from "../MobotixTab";
import ErrorBoundary from "../../../../ErrorBoundary";
import { SentinelAlertsTab } from "../SentinelAlertsTab";
import { SentinelAlertsTabEditMode } from "../SentinelAlertsTabEditMode";
import { BoldAlertsTab } from "../BoldAlertsTab";
import { BoldAlertsTabEditMode } from "../BoldAlertsTabEditMode";
import { PatriotAlertsTab } from "../PatriotAlertsTab";
import { PatriotAlertsTabEditMode } from "../PatriotAlertsTabEditMode";
import { USMonitoringAlertsTab } from "../USMonitoringAlertsTab";
import { USMonitoringAlertsTabEditMode } from "../USMonitoringAlertsTabEditMode";
import { SoftguardAlertsTab } from "../SoftguardAlertsTab";
import { SoftguardAlertsTabEditMode } from "../SoftguardAlertsTabEditMode";
import { StreamParametersTab } from "../StreamParametersTab";
import { StreamParametersTabEditMode } from "../StreamParametersTabEditMode";
import { AlertSettingsTab } from "../AlertSettingsTab";
import { AlertSettingsTabEditMode } from "../AlertSettingsTabEditMode";
import { SlicingTab } from "../SlicingTab";
import { SlicingTabEditMode } from "../SlicingTabEditMode";
import { VlmTab } from "../VlmTab";
import { VlmTabEditMode } from "../VlmTabEditMode";

export const handleTabChangeEditCamera = (
  tabValue: any,
  editMode: boolean,
  setClickedTab: any,
  setActiveTab: any,
  siteInfo: any,
  cameraGeneralInfo: any,
  setCameraGeneralInfo: any,
  setPatchObject: any,
  setGeneralInfoChangesMade: any,
  immixAlerts: any,
  diceAlerts: any,
  setActiveChangeMade: any,
  sureviewAlerts: any,
  setAddImmixAlertDialogOpen: any,
  setAddDiceAlertDialogOpen: any,
  setAddSureviewAlertDialogOpen: any,
  streamsObject: any,
  activeProducts: any,
  recipientsConfiguredData: any,
  titlesArray: any,
  navigate: NavigateFunction,
  setBackdropLoadingScreenOn: Dispatcher<boolean>,
  setRecipientsConfiguredData: any,
  setTitlesArray: any,
  actionRulesData: any,
  setActionRulesData: Dispatcher<any>,
  actionRulesTitlesArray: any,
  setActionRulesTitlesArray: Dispatcher<any>,
  applicationsConfiguredData: any,
  timeTablesData: any,
  setTimeTablesData: any,
  iPNotifyData: any,
  setIPNotifyData: any,
  actionHandlerData: any,
  setActionHandlerData: any,
  axisFinished: any,
  setSendingImmixTest: Dispatcher<boolean>,
  setImmixTestSuccessDialogOpen: Dispatcher<boolean>,
  setImmixTestFailDialogOpen: Dispatcher<boolean>,
  setSendingDiceTest: Dispatcher<boolean>,
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>,
  setDiceTestFailDialogOpen: Dispatcher<boolean>,
  cameraWebhookData: any,
  setCameraWebhooksPatchObject: any,
  setCameraWebhooksChangesMade: Dispatcher<boolean>,
  productsData: any,
  setProductsData: Dispatcher<any>,
  allTabsOpen: boolean,
  setAllTabsOpen: Dispatcher<boolean>,
  setBackupProductsData: any,
  sentinelAlerts: any,
  setAddSentinelAlertDialogOpen: any,
  boldAlerts: any,
  setAddBoldAlertDialogOpen: Dispatcher<boolean>,
  patriotAlerts: any,
  setAddPatriotAlertDialogOpen: Dispatcher<boolean>,
  uSMonitoringAlerts: any,
  setAddUSMonitoringAlertDialogOpen: Dispatcher<boolean>,
  softguardAlerts: any,
  setAddSoftguardAlertDialogOpen: Dispatcher<boolean>,
  streamParametersData: any,
  streamParametersPatchObject: any,
  setStreamParametersPatchObject: any,
  setStreamParametersChangesMade: Dispatcher<boolean>,
  setAddStreamWebhookDialogOpen: Dispatcher<boolean>,
  setEditStreamWebhookDialogOpen: Dispatcher<boolean>,
  setDeleteImmixAlertDialogOpen: Dispatcher<boolean>,
  setDeleteDiceAlertDialogOpen: Dispatcher<boolean>,
  immixAlertsOnCamera: boolean,
  diceAlertsOnCamera: boolean,
  sureViewAlertsOnCamera: boolean,
  webhooksAlertsOnCamera: boolean,
  sentinelAlertsOnCamera: boolean,
  boldAlertsOnCamera: boolean,
  patriotAlertsOnCamera: boolean,
  softguardAlertsOnCamera: boolean,
  evalinkAlertsOnCamera: boolean
) => {
  setClickedTab(tabValue);
  localStorage.setItem("editCamerActiveTab", tabValue);
  if (tabValue === "one" && !editMode) {
    setActiveTab(
      <ErrorBoundary>
        <GeneralInfoEditCameraTab
          siteInfo={siteInfo}
          cameraGeneralInfo={cameraGeneralInfo}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "one" && editMode) {
    setActiveTab(
      <ErrorBoundary>
        <GeneralInfoEditCameraTabEditMode
          siteInfo={siteInfo}
          cameraGeneralInfo={cameraGeneralInfo}
          setCameraGeneralInfo={setCameraGeneralInfo}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
          setActiveChangeMade={setActiveChangeMade}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "two" && !editMode) {
    setActiveTab(
      <ErrorBoundary>
        <ConnectionsTab cameraGeneralInfo={cameraGeneralInfo} />{" "}
      </ErrorBoundary>
    );
  } else if (tabValue === "two" && editMode) {
    setActiveTab(
      <ErrorBoundary>
        <ConnectionsTabEditMode
          cameraGeneralInfo={cameraGeneralInfo}
          setCameraGeneralInfo={setCameraGeneralInfo}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "three" && !editMode) {
    setActiveTab(
      <ErrorBoundary>
        <NotificationsTab cameraGeneralInfo={cameraGeneralInfo} />
      </ErrorBoundary>
    );
  } else if (tabValue === "three" && editMode) {
    setActiveTab(
      <ErrorBoundary>
        <NotificationsTabEditMode
          cameraGeneralInfo={cameraGeneralInfo}
          setCameraGeneralInfo={setCameraGeneralInfo}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "four" && !editMode) {
    setActiveTab(
      <ErrorBoundary>
        <ProductsTab
          productsData={productsData}
          setProductsData={setProductsData}
          allTabsOpen={allTabsOpen}
          setAllTabsOpen={setAllTabsOpen}
          setBackupProductsData={setBackupProductsData}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "four" && editMode) {
    setActiveTab(
      <ErrorBoundary>
        <ProductsTabEditMode
          activeProducts={activeProducts}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
          cameraGeneralInfo={cameraGeneralInfo}
          productsData={productsData}
          setProductsData={setProductsData}
          allTabsOpen={allTabsOpen}
          setAllTabsOpen={setAllTabsOpen}
          setBackupProductsData={setBackupProductsData}
          siteInfo={siteInfo}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "five" && !editMode) {
    setActiveTab(
      <ErrorBoundary>
        <SlicingTab />
      </ErrorBoundary>
    );
  } else if (tabValue === "five" && editMode) {
    setActiveTab(
      <ErrorBoundary>
        <SlicingTabEditMode />
      </ErrorBoundary>
    );
  } else if (tabValue === "seventeen" && !editMode) {
    setActiveTab(
      <ErrorBoundary>
        <VlmTab />
      </ErrorBoundary>
    );
  } else if (tabValue === "seventeen" && editMode) {
    setActiveTab(
      <ErrorBoundary>
        <VlmTabEditMode />
      </ErrorBoundary>
    );
  } else if (tabValue === "seven") {
    setActiveTab(
      <ErrorBoundary>
        <AxisTab
          recipientsConfiguredData={recipientsConfiguredData}
          titlesArray={titlesArray}
          navigate={navigate}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setRecipientsConfiguredData={setRecipientsConfiguredData}
          setTitlesArray={setTitlesArray}
          actionRulesData={actionRulesData}
          setActionRulesData={setActionRulesData}
          actionRulesTitlesArray={actionRulesTitlesArray}
          setActionRulesTitlesArray={setActionRulesTitlesArray}
          setActiveTab={setActiveTab}
          applicationsConfiguredData={applicationsConfiguredData}
          cameraGeneralInfo={cameraGeneralInfo}
          axisFinished={axisFinished}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "eight") {
    setActiveTab(
      <ErrorBoundary>
        <MobotixTab
          timeTablesData={timeTablesData}
          navigate={navigate}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setTimeTablesData={setTimeTablesData}
          setActiveTab={setActiveTab}
          iPNotifyData={iPNotifyData}
          setIPNotifyData={setIPNotifyData}
          actionHandlerData={actionHandlerData}
          setActionHandlerData={setActionHandlerData}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "fifteen" && !editMode) {
    setActiveTab(
      <ErrorBoundary>
        <StreamParametersTab
          streamParametersData={streamParametersData}
          siteInfo={siteInfo}
        />{" "}
      </ErrorBoundary>
    );
  } else if (tabValue === "fifteen" && editMode) {
    setActiveTab(
      <ErrorBoundary>
        <StreamParametersTabEditMode
          streamParametersData={streamParametersData}
          streamParametersPatchObject={streamParametersPatchObject}
          setStreamParametersPatchObject={setStreamParametersPatchObject}
          setStreamParametersChangesMade={setStreamParametersChangesMade}
          siteInfo={siteInfo}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "sixteen" && !editMode) {
    localStorage.setItem(
      "softguardAlertsBackup",
      JSON.stringify(softguardAlerts)
    );
    setActiveTab(
      <ErrorBoundary>
        <AlertSettingsTab
          immixAlerts={immixAlerts}
          setAddImmixAlertDialogOpen={setAddImmixAlertDialogOpen}
          setSendingImmixTest={setSendingImmixTest}
          setImmixTestSuccessDialogOpen={setImmixTestSuccessDialogOpen}
          setImmixTestFailDialogOpen={setImmixTestFailDialogOpen}
          setDeleteImmixAlertDialogOpen={setDeleteImmixAlertDialogOpen}
          diceAlerts={diceAlerts}
          setAddDiceAlertDialogOpen={setAddDiceAlertDialogOpen}
          setSendingDiceTest={setSendingDiceTest}
          setDiceTestSuccessDialogOpen={setDiceTestSuccessDialogOpen}
          setDiceTestFailDialogOpen={setDiceTestFailDialogOpen}
          setDeleteDiceAlertDialogOpen={setDeleteDiceAlertDialogOpen}
          sureviewAlerts={sureviewAlerts}
          setAddSureviewAlertDialogOpen={setAddSureviewAlertDialogOpen}
          setAddStreamWebhookDialogOpen={setAddStreamWebhookDialogOpen}
          setEditStreamWebhookDialogOpen={setEditStreamWebhookDialogOpen}
          sentinelAlerts={sentinelAlerts}
          setAddSentinelAlertDialogOpen={setAddSentinelAlertDialogOpen}
          boldAlerts={boldAlerts}
          setAddBoldAlertDialogOpen={setAddBoldAlertDialogOpen}
          patriotAlerts={patriotAlerts}
          setAddPatriotAlertDialogOpen={setAddPatriotAlertDialogOpen}
          softguardAlerts={softguardAlerts}
          setAddSoftguardAlertDialogOpen={setAddSoftguardAlertDialogOpen}
          immixAlertsOnCamera={immixAlertsOnCamera}
          diceAlertsOnCamera={diceAlertsOnCamera}
          sureViewAlertsOnCamera={sureViewAlertsOnCamera}
          siteInfo={siteInfo}
          webhooksAlertsOnCamera={webhooksAlertsOnCamera}
          sentinelAlertsOnCamera={sentinelAlertsOnCamera}
          boldAlertsOnCamera={boldAlertsOnCamera}
          patriotAlertsOnCamera={patriotAlertsOnCamera}
          softguardAlertsOnCamera={softguardAlertsOnCamera}
          evalinkAlertsOnCamera={evalinkAlertsOnCamera}
          navigate={navigate}
        />
      </ErrorBoundary>
    );
  } else if (tabValue === "sixteen" && editMode) {
    setActiveTab(
      <ErrorBoundary>
        <AlertSettingsTabEditMode
          immixAlerts={immixAlerts}
          diceAlerts={diceAlerts}
          sureviewAlerts={sureviewAlerts}
          setEditStreamWebhookDialogOpen={setEditStreamWebhookDialogOpen}
          sentinelAlerts={sentinelAlerts}
          boldAlerts={boldAlerts}
          patriotAlerts={patriotAlerts}
          softguardAlerts={softguardAlerts}
          immixAlertsOnCamera={immixAlertsOnCamera}
          diceAlertsOnCamera={diceAlertsOnCamera}
          sureViewAlertsOnCamera={sureViewAlertsOnCamera}
          siteInfo={siteInfo}
          webhooksAlertsOnCamera={webhooksAlertsOnCamera}
          sentinelAlertsOnCamera={sentinelAlertsOnCamera}
          boldAlertsOnCamera={boldAlertsOnCamera}
          patriotAlertsOnCamera={patriotAlertsOnCamera}
          softguardAlertsOnCamera={softguardAlertsOnCamera}
          evalinkAlertsOnCamera={evalinkAlertsOnCamera}
          cameraGeneralInfo={cameraGeneralInfo}
          setPatchObject={setPatchObject}
          setGeneralInfoChangesMade={setGeneralInfoChangesMade}
          setAddStreamWebhookDialogOpen={setAddStreamWebhookDialogOpen}
        />
      </ErrorBoundary>
    );
  }
};
